var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoto = function SvgPhoto(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.5V20.2316C31 23.6508 31 25.3605 30.346 26.6665C29.7708 27.8152 28.8529 28.7492 27.7239 29.3346C26.4405 30 24.7603 30 21.4 30H10.6C7.23969 30 5.55953 30 4.27606 29.3346C3.14708 28.7492 2.2292 27.8152 1.65396 26.6665C1 25.3605 1 23.6508 1 20.2316V12.2947C1 8.87547 1 7.16584 1.65396 5.85985C2.2292 4.71107 3.14708 3.77708 4.27606 3.19175C5.55953 2.52632 7.23969 2.52632 10.6 2.52632H16.75M26.5 10.1579V1M22 5.57895H31M22 16.2632C22 19.635 19.3137 22.3684 16 22.3684C12.6863 22.3684 10 19.635 10 16.2632C10 12.8913 12.6863 10.1579 16 10.1579C19.3137 10.1579 22 12.8913 22 16.2632Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoto);
export default ForwardRef;